import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Valida que el control actual sea igual al control hermano `otherControlName`
 * dentro del mismo FormGroup. Usado para `password_confirmation` en registro
 * y reset de contraseña.
 */
export function matchesField(otherControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const parent = control.parent;
    if (!parent) return null;

    const other = parent.get(otherControlName);
    if (!other) return null;

    if (control.value == null || control.value === '') return null;
    return control.value === other.value ? null : { matchesField: true };
  };
}
